export default "__VITE_ASSET__c7fb15c2__"